import React, { useState, useEffect } from "react";
import './CookieModal.css';

const CookieModal = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookiesConsent');
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookiesConsent', 'accepted');
    setIsVisible(false);
  };

  const handleReject = () => {
    localStorage.setItem('cookiesConsent', 'rejected');
    setIsVisible(false);
  };

  const handleMoreInfo = () => {
    window.open('https://www.sageservice.es/politica-de-cookies', '_blank');
  };

  if (!isVisible) return null;

  return (
    <div className="cookie-modal">
      <div className="cookie-modal-content">
        <button className="close" onClick={() => setIsVisible(false)}>&times;</button>
        <h2>Política de Cookies</h2>
        <p>
          AL-ANDALUS FEELING SLU, en su Web, <a href="https://www.sageservice.es/" target="_blank" rel="noopener noreferrer">https://www.sageservice.es/</a>, utiliza cookies y otras tecnologías similares que almacenan y recuperan información cuando navegas. Estas tecnologías pueden servir para finalidades diversas, como reconocer a un usuario y obtener información de sus hábitos de navegación. Los usos concretos que hacemos de estas tecnologías se describen en la información de la Política de Cookies.
        </p>
        <p>
          En esta web, disponemos de cookies propias y de terceros para el acceso y registro al formulario de los usuarios. La información sobre las cookies la recibirá en el Botón de <strong>MAS INFORMACIÓN</strong>, en la Política de Cookies.
        </p>
        <p>
          En atención a la Guía sobre el uso de las cookies aprobada en el mes de julio de 2023, de la AEPD y con los criterios del Comité Europeo en Protección de Datos, (CEPD), por el RGPD-UE-2016/679, la LOPDGDD-3/2018, y la LSSI-CE-34/2002, última actualización, 09/05/2023, solicitaremos su consentimiento para el uso de cookies en nuestra web.
        </p>
        <div className="cookie-buttons">
          <button onClick={handleAccept}>ACEPTAR</button>
          <button onClick={handleReject}>RECHAZAR</button>
          <button onClick={handleMoreInfo}>MAS INFORMACIÓN</button>
        </div>
      </div>
    </div>
  );
};

export default CookieModal;
